import { NgModule } from '@angular/core';

import { CoreSidebarComponent } from 'app/back-office/layout/core-sidebar/core-sidebar.component';

/**
 * Wrapper di compatibilità: CoreSidebarComponent è standalone.
 * Il modulo resta solo per i molti moduli feature che lo importano.
 */
@NgModule({
  imports: [CoreSidebarComponent],
  exports: [CoreSidebarComponent]
})
export class CoreSidebarModule { }
